import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { Alert, Box, Button, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Title } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ImgUploadDialog from '../../../../../../components/ImgUpload/imgUpload';
import DocumentUploadDialog from '../../../../../../components/fileUpload/DocumentUpload';
import { Helpers } from '../../../../../../services/Helpers';
import { NotificationDataContext } from '../../../AddEditNotification';
import { WhatsappDataContext } from '../WhatsappMessageContent';

const MediaContent = () => {
    const {notificationData} = useContext(NotificationDataContext);
    const {initialWhatsappData} =useContext(WhatsappDataContext)
    const { control, watch, setValue } = useFormContext();

    const mediaType = watch('mediaType');
    const [imgOpen, setImgOpen] = useState(false);
    const [docOpen, setDocOpen] = useState(false);

    const uploadFolder = 'whatsapp/campaign';
    // useMemo(() => {
    //     if (!mediaType) return 'whatsapp/uploads';
    //     return `whatsapp/${mediaType}`;
    // }, [mediaType]);

    const fileCategory = useMemo(() => {
        if (mediaType === 'video') return 'video';
        if (mediaType === 'audio') return 'audio';
        return 'document';
    }, [mediaType]);

    const openUpload = () => {
        if (!mediaType) return;
        if (mediaType === 'image') setImgOpen(true);
        else setDocOpen(true);
    };

    const closeImg = () => setImgOpen(false);
    const closeDoc = () => setDocOpen(false);

    const extractUploadedUrl = (data) => {
        if (!data) return '';
        if (data.fileUrl) return data.fileUrl;
        if (data.Location) return data.Location;
        if (data.url) return data.url;
        if (data.fullUrl) return data.fullUrl;
        if (data.imageBaseUrl && data.imageDirectory && data.imageName) {
            return `${data.imageBaseUrl}${data.imageDirectory}${data.imageName}`;
        }
        if (data.imageDirectory && data.imageName) {
            return `${Helpers.ImagePathUrl()}${data.imageDirectory}${data.imageName}`;
        }
        if (data.imageName) {
            return `${Helpers.ImagePathUrl()}/${uploadFolder}/${data.imageName}`;
        }
        return '';
    };

    const onUploadResponse = (data) => {
        console.log('Uploaded data received in MediaContent:', data);
        const url = extractUploadedUrl(data);
        if (url) {
            setValue('mediaUrl', url, { shouldDirty: true, shouldValidate: true });
        }
        closeImg();
        closeDoc();
    };
    
    useEffect(() => {
        const whatsappDelivery = notificationData?.deliveryModes?.includes('whatsapp');
        const messageType = notificationData?.whatsappData?.messageType;

        if ( whatsappDelivery && messageType === 'media'){
            setValue('mediaType', notificationData?.whatsappData?.mediaType || '', { shouldDirty: true, shouldValidate: true });
            setValue('mediaUrl', notificationData?.whatsappData?.mediaUrl || '', { shouldDirty: true, shouldValidate: true });
            setValue('caption', notificationData?.whatsappData?.caption || '', { shouldDirty: true, shouldValidate: true });
        } else {
            setValue('mediaUrl', '', { shouldDirty: true, shouldValidate: true });
            setValue('caption', '', { shouldDirty: true, shouldValidate: true });
        }
        // setValue('mediaUrl', '', { shouldDirty: true, shouldValidate: true });
        // setValue('caption', '', { shouldDirty: true, shouldValidate: true });
    }, [mediaType]);

    return (
        <>
            <Box>
                <Card>
                    <CardContent sx={{ height: 'max-content' }}>
                        <Typography gutterBottom sx={{ mb: 1, fontWeight: 600, fontSize: '0.85rem' }}>
                            Notification Content
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}
                                        >
                                            <Title color="primary" />
                                            Compose Your Message
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    name="mediaType"
                                                    control={control}
                                                    rules={{ required: 'select media type' }}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <FormControl fullWidth size='small' error={!!error}>
                                                            <InputLabel id="media-type-label" sx={{ fontSize: '0.8rem' }}>
                                                                Media Type
                                                            </InputLabel>
                                                            <Select
                                                                {...field}
                                                                labelId="media-type-label"
                                                                id="media-type-select"
                                                                label="Media Type"
                                                                sx={{
                                                                    fontSize: '0.75rem',
                                                                    '& .MuiSelect-select': {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                    },
                                                                }}
                                                            >
                                                                <MenuItem value="document" sx={{ fontSize: '0.75rem' }}>Document</MenuItem>
                                                                <MenuItem value="image" sx={{ fontSize: '0.75rem' }}>Image</MenuItem>
                                                                <MenuItem value="video" sx={{ fontSize: '0.75rem' }}>Video</MenuItem>
                                                                <MenuItem value="audio" sx={{ fontSize: '0.75rem' }}>Audio</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name="mediaUrl"
                                                    rules={{ required: 'please enter media url or upload media' }}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            disabled ={!mediaType}
                                                            label="Media URL"
                                                            onChange={(e) => {
                                                                const cleanedValue = e.target.value
                                                                    .replace(/\s+/g, ' ')
                                                                    .trimStart();
                                                                field.onChange(cleanedValue);
                                                            }}
                                                            size="small"
                                                            sx={{ mb: 2 }}
                                                            InputProps={{ style: { fontSize: '0.8rem' } }}
                                                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                                                            error={!!error}
                                                            helperText={error?.message}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                {(mediaType && (mediaType=='image' || mediaType == 'document'))?
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        startIcon={<CloudUploadIcon />}
                                                        fullWidth
                                                        disabled={!mediaType}
                                                        onClick={openUpload}
                                                    >
                                                        {mediaType ? `Upload ${mediaType}` : 'Select media type'}
                                                    </Button>
                                                    :
                                                    mediaType && <Alert severity="info">
                                                        <Typography sx={{fontSize:'0.8rem'}}>{`Collect ${mediaType} link from Team and paste it in the Media URL field.`}</Typography>
                                                    </Alert>
                                                }
                                                
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name="caption"
                                                    rules={{
                                                        // required: 'please enter media caption',
                                                        validate: value => value.length <= 200 || 'Caption exceeds 200 characters'
                                                    }}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="Media Caption"
                                                            multiline
                                                            onChange={(e) => {
                                                                const cleanedValue = e.target.value
                                                                    .replace(/\s+/g, ' ')
                                                                    .trimStart();
                                                                if (cleanedValue?.length <= 200) {
                                                                    field.onChange(cleanedValue);
                                                                    return;
                                                                }
                                                                const limitedValue = cleanedValue.slice(0, 200);
                                                                field.onChange(limitedValue);
                                                            }}
                                                            size="small"
                                                            InputProps={{ style: { fontSize: '0.75rem' } }}
                                                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                                                            error={!!error}
                                                            helperText={`${watch('caption')?.length}/200 characters recommended`}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    control={control}
                                                    name="filename"
                                                    rules={{
                                                        // required: 'please enter media caption',
                                                        validate: value => value.length <= 50 || 'file Name exceeds 50 characters'
                                                    }}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="File Name"
                                                            multiline
                                                            onChange={(e) => {
                                                                const cleanedValue = e.target.value
                                                                    .replace(/\s+/g, ' ')
                                                                    .trimStart();
                                                                if (cleanedValue?.length <= 50) {
                                                                    field.onChange(cleanedValue);
                                                                    return;
                                                                }
                                                                const limitedValue = cleanedValue.slice(0, 50);
                                                                field.onChange(limitedValue);
                                                            }}
                                                            size="small"
                                                            InputProps={{ style: { fontSize: '0.75rem' } }}
                                                            InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                                                            error={!!error}
                                                            helperText={`${watch('caption')?.length}/50 characters recommended`}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                        
                                        
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
            <ImgUploadDialog
                open={imgOpen}
                onClose={closeImg}
                imgData={{ path: uploadFolder }}
                imgUploadResponse={onUploadResponse}
            />
            <DocumentUploadDialog
                open={docOpen}
                onClose={closeDoc}
                uploadData={{ path: uploadFolder }}
                onUploadResponse={onUploadResponse}
                fileCategory={fileCategory}
                dialogTitle={mediaType ? `Upload ${mediaType}` : 'Upload File'}
            />
        </>
    );
};

export default MediaContent
